module.exports = __webpack_public_path__ + "img/d2.0e40ba19.jpg";